import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam } from '../service-base';
import { TransactionServiceBase } from './abstract/transaction-service.base';

// Modèles
import { CashTransaction } from 'src/app/@shared/models/banking/cash-transactions/cash-transaction.model';

const CLASS_NAME = 'CashTransaction';
const ENDPOINT = `/cash-transactions/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
    { key: 'potential-settlements', path: 'potential-settlements/', childClass: 'Settlement' },
    { key: 'settlements', path: 'settlements/', childClass: 'Settlement' },
]
const ROUTES: RouteParam[] = [
    { key: 'export', path: 'export/' },
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'recordOverpayment', path: '{id}/record-overpayment/' },
]

@Injectable({
    providedIn: 'root'
})
export class CashTransactionService extends TransactionServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public recordOverpayment$(transaction: CashTransaction): Observable<CashTransaction> {
        return this.update$(transaction, {
            url: this.routes.recordOverpayment.replace('{id}', transaction.id.toString())
        });
    }
}
